export default __webpack_public_path__ + "static/media/landing_desktop.d1d8d8db.gif";